import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import {AutoCompleteComponent} from 'ionic2-auto-complete';
import { CarteraServiceProvider } from '../../providers/cartera-service/cartera-service';
import { EntidadServiceProvider} from '../../providers/entidad-service/entidad-service';
import { AuthServiceProvider } from '../../providers/auth-service/auth-service';

/**
 * Generated class for the SaldosPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-saldos',
  templateUrl: 'saldos.html',
})
export class SaldosPage {

	@ViewChild('proveedor') proveedor: AutoCompleteComponent
  departamentos: any ;
  entidad={id:0, descripcion:'', idtusuario:0};

  constructor(public navCtrl: NavController, public navParams: NavParams, public loadingCtrl: LoadingController,
    public carteraProvider: CarteraServiceProvider, public authService : AuthServiceProvider,
    public entidadService: EntidadServiceProvider, public alertCtrl: AlertController,) {

    this.entidadService.idtentidad = 2; //CONDOMINOS

    this.entidad.idtusuario = this.authService.usuario['idtusuario'];
    if(this.entidad.idtusuario == 1){
      this.entidad.id = this.authService.usuario['identidad'];
      this.entidad.descripcion = this.authService.usuario['entidad'];
    }
  }

  ionViewDidLoad() {
    if(this.entidad.idtusuario == 1){

      this.consultar();
    }
  }

  itemClick(evento, item)
  {
  		window.open(this.carteraProvider.serverServicios + "/departamento"+ item.id +".pdf", "_blank");
  		console.log(item);
  }

  consultar(){
    if(this.entidad.id == 0){
        let alert = this.alertCtrl.create({
          title: 'Validacion de datos',
          subTitle: 'Seleccione el condómino para ejecutar la busqueda',
          buttons: ['OK']
        });
        alert.present();
    }
    else{
      let loading = this.loadingCtrl.create({
      content: 'Cargando, espere por favor...'
      });
      loading.present();

      this.carteraProvider.getReporte(1, this.entidad.id).then(data=>{      
        this.departamentos=data;
        loading.dismiss();
      },(err) => {
          loading.dismiss();
      })
    }
  }

  seleccionarProveedor(evento)
  {
    
    let descripcion = evento.descripcion;
    if(this.entidad.idtusuario != 1){
      this.proveedor.setValue(descripcion);
      this.entidad.descripcion = descripcion;
      this.entidad.id = evento.id;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/saldos/saldos.ts